<template>
  <button
    class="flex items-center gap-2 border rounded-lg w-full px-3 h-11 justify-center text-[15px]"
    :class="[
      classes,
      mode === 'dark'
        ? 'hover:bg-dark-70 border-dark-50'
        : 'hover:bg-gray-20 hover:bg-opacity-10',
    ]"
    @click="handleLogin"
  >
    <img class="w-5 h-5" src="../../assets/img/google_logo.png" alt="logo" />
    <span>{{ label }}</span>
  </button>
</template>

<script>
import { googleTokenLogin } from "vue3-google-login";
import helper from "../../libs/helper";
import ApiRequest from "../../libs/ApiRequest";
import { useUserStore } from "../../stores/user";

export default {
  name: "SignInWithGoogleButton",
  setup() {
    const userStore = useUserStore();
    return {
      userStore,
      redirectUrl: null,
    };
  },
  props: {
    label: {
      type: String,
      default: "Continue with Google",
    },
    classes: {
      type: String,
      default: "",
    },
    mode: {
      type: String,
      default: "",
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.hasOwnProperty("plan")) {
      const planParam = this.$route.query["plan"].split("_")[0];
      const tierParam = this.$route.query["plan"].split("_")[1];
      this.redirectUrl = "/payments/order?plan=" + planParam + "_" + tierParam;
    }
  },
  methods: {
    async handleLogin() {
      try {
        googleTokenLogin().then(async (response) => {
          this.userStore.setIsLoading(!0);
          const url = "api/auth/google/login";
          const { data } = await ApiRequest().post(url, response);
          if (data && data.access) {
            await this.userStore.setLoginToken(data);
            this.userStore.setLogin(!0);
            if (this.$route.name === "signup2") {
              this.userStore.setIsLoading(!1);
              this.$toast.success("Account created successfully");
              this.$emit("on-signup", this.$route, data);
            } else {
              if (this.redirectUrl) {
                this.$router.push(this.redirectUrl);
              } else {
                if (this.$route.query.redirectUrl) {
                  this.$router.push(this.$route.query.redirectUrl);
                } else {
                  this.$router.push({ name: "dashboard" });
                }
              }
            }
          }
          this.userStore.setIsLoading(!1);
        });
      } catch (error) {
        const extractedError = helper.extractAlert(error, "signin");
        this.$toast.error(extractedError.alert.message);
      }
    },
  },
};
</script>
